import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { recipesData, newRecipe } from '__mocks__/mockData/patient-recipes-data';

const PatientRecipesApi = [
  rest.get(`${API_ROOT}patient-recipes`, (req, res, ctx) => res(ctx.json(recipesData))),
  rest.get(`${API_ROOT}patient-recipes/${recipesData[0].id}`, (req, res, ctx) => res(ctx.json(recipesData[0]))),
  rest.delete(`${API_ROOT}patient-recipes/${recipesData[0].id}`, (req, res, ctx) => res(ctx.json(recipesData))),
  rest.post(`${API_ROOT}patient-recipes`, (req, res, ctx) => res(ctx.json(newRecipe))),
];
export default PatientRecipesApi;
